<template>
  <div>
    <h3 class="title-with_border">Cloud PBX</h3>
    <div class="va-row">
      <div class="flex md3 xs12 mx-auto">
        <div class="form-group with-icon-left">
          <div class="input-group">
            <input
              class="search-input"
              name="input-icon-left"
              v-model="filter"
              required
              placeholder="Search"
            />
            <i
              class="glyphicon glyphicon-search icon-left input-icon search-icon"
            ></i>
            <half-circle-spinner
              slot="loading"
              :animation-duration="1500"
              :size="20"
              v-show="loading"
              color="#94c120"
              class="filter-loading"
            />
          </div>
        </div>
      </div>
    </div>
    <FAQ :articles="articles" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FAQ from './helpcenter/FAQ'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'

export default {
  name: 'HelpCenterTab',
  components: {
    HalfCircleSpinner,
    FAQ
  },
  data() {
    return {
      filter: '',
      loading: false
    }
  },
  watch: {
    async filter(val) {
      if (!val) {
        this.loading = true
        await this.fetchArticles(val)
        this.loading = false
      }
      if (val && val.length > 2) {
        this.loading = true
        await this.fetchArticles(val)
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['articles'])
  },
  methods: {
    ...mapActions(['fetchArticles'])
  },
  created() {
    if (!this.articles.length) {
      this.fetchArticles()
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-loading {
  position: absolute;
  top: 8px;
  right: 1rem;
}
h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  &.title-with_border {
    &:after {
      content: '';
      display: block;
      width: 100%;
      border-bottom: 2px solid $lighter-gray;
      margin-top: 5px;
    }
  }
}
.form-group {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
label {
  margin-bottom: 0;
}
.va-row:not(:only-child) {
  margin: 20px -0.5rem !important;
}
.search-input {
  border: 1px solid $light-gray;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  padding: 10px 30px !important;
  height: 36px;
}
.search-icon {
  transform: rotate(90deg);
  left: 10px !important;
  top: 10px !important;
  color: lighten($gray, 10%);
}
@media (max-width: 768px) {
  .form-group {
    width: 80%;
  }
}
</style>
